// extracted by mini-css-extract-plugin
module.exports = {"avatar-container":"avatar-container","avatar":"avatar"};